import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Carousel from "../Catalog/Carousel";
import Collection from "../Catalog/Collection";
import Item from "./Item";

const templates = {
    carousel: Carousel,
    grid: Collection
};

class ManufacturerWidget extends React.Component {
    constructor(props){
        super(props);

        let imageOnlyFilterGroup = {
            field: "image",
            value: "null",
            condition: "notnull"
        };

        let initialFilterGroups = props.filterGroups;

        initialFilterGroups.push(imageOnlyFilterGroup);


        this.state = {
            data: [],
            filterGroups: initialFilterGroups
        };

        this.fetchData = this.fetchData.bind(this);
    }
    fetchData(){
        let query = "";

        query += `filterGroups=${JSON.stringify(this.state.filterGroups)}&`;

        if(this.props.sortOrders.length > 0){
            query += `sortGroups=${JSON.stringify(this.props.sortOrders)}&`;
        }

        if(this.props.pageSize && (typeof this.props.pageSize == "number") && this.props.pageCount && (typeof this.props.pageCount == "number")){
            query += `pageSize=${this.props.pageSize * this.props.pageCount}&`;
        }

        axios.get(`/api/manufacturers/brands/search?${query}`)
            .then((manufacturerResults)=>{
                this.setState({
                    data: manufacturerResults.data.brands
                });
            }).catch((err)=>{
                console.error(err);
            });
    }
    componentDidMount(){
        this.fetchData();
    }
    render(){
        const Template = templates[this.props.template];

        if(this.state.data && this.state.data.length > 0){
            return(
                <div className="col-sm-12">
                    {this.props.title && (
                        <h2 className="title">{this.props.title}</h2>
                    )}
                    <Template
                        data={this.state.data}
                        itemComponent={Item}
                        pageSize={this.props.pageSize}
                        loop={this.props.loop}
                        speed={this.props.speed}
                        autoPlay={this.props.autoPlay}
                        autoPlayInterval={this.props.autoPlayInterval}
                        className="manufacturer-grid mb-2"
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

ManufacturerWidget.defaultProps = {
    template: "grid",
    pageSize: 5,
    pageScroll: 1,
    pageCount: 1,
    autoPlay: false,
    autoPlayInterval: 3000,
    speed: 500,
    loop: true
};

ManufacturerWidget.propTypes = {
    title: PropTypes.string,
    pageSize: PropTypes.number,
    pageCount: PropTypes.number,
    pageScroll: PropTypes.number,
    autoPlay: PropTypes.bool,
    autoPlayInterval: PropTypes.number,
    speed: PropTypes.number,
    loop: PropTypes.bool,
    template: PropTypes.string,
    filterGroups: PropTypes.array,
    sortOrders: PropTypes.array
};

export {ManufacturerWidget};
